import React, { createContext, useContext, useState } from 'react';

const ChartContext = createContext();

export const useChart = () => {
  const context = useContext(ChartContext);
  if (!context) {
    throw new Error('useChart must be used within a ChartProvider');
  }
  return context;
};

export const ChartProvider = ({ children }) => {
  const [selectedMetal, setSelectedMetal] = useState('GOLD');
  const [selectedWeight, setSelectedWeight] = useState('oz');

  const selectMetal = (metal, weight = 'oz') => {
    setSelectedMetal(metal);
    setSelectedWeight(weight);
    // Scroll disabled per user request
  };

  return (
    <ChartContext.Provider value={{ selectedMetal, setSelectedMetal, selectedWeight, setSelectedWeight, selectMetal }}>
      {children}
    </ChartContext.Provider>
  );
};
